module.exports = __webpack_public_path__ + "img/partseven_pic3.b2b2161c.png";